import { PublicCourseReview } from '@shared/types';
import { PublicEducator } from '@cademy-package/sdk-component-types';
import { FunctionComponent, useMemo } from 'react';
import Button from '../../../../../components/Button';
import { CloseSolidIcon } from '../../../../../components/Icons';
import Modal from '../../../../../components/Modal';
import Review from '../../../../../components/Review';
import useCourseReviews from './Hooks/useCourseReviews';
import styles from './styles.module.scss';
import useEducatorReviews from './Hooks/useEducatorReviews';

export type ReviewsModalProps = {
    visible: boolean;
    onClose: () => void;
    educator: PublicEducator;
    reviews: Array<PublicCourseReview>;
    fetchNext: (() => void) | null;
};

const ReviewsModal: FunctionComponent<ReviewsModalProps> = ({
    visible,
    onClose,
    educator,
    reviews,
    fetchNext,
}) => {
    const courseReviewCards = useMemo(
        () =>
            reviews.map((review, index) => {
                return <Review key={index} review={review} educator={educator} />;
            }),
        [educator, reviews]
    );

    if (!visible && courseReviewCards.length > 0) {
        return <div>{courseReviewCards.slice(0, 5)}</div>;
    }

    if (!visible) {
        return null;
    }

    return (
        <Modal className={styles.modal} size="medium" onClose={onClose}>
            <div className={styles.header}>
                <h2>All Reviews</h2>
                <Button className={styles.close} onClick={onClose}>
                    <CloseSolidIcon />
                </Button>
            </div>

            <div>{courseReviewCards}</div>

            <LoadMoreButton onClick={fetchNext} />
        </Modal>
    );
};

type LoadMoreButtonProps = {
    onClick: (() => void) | null;
};

const LoadMoreButton: FunctionComponent<LoadMoreButtonProps> = ({ onClick }) => {
    if (!onClick) {
        return null;
    }

    return (
        <div className={styles.loadMoreButton}>
            <Button onClick={onClick}>Load more</Button>
        </div>
    );
};

export default ReviewsModal;
